import axios from "axios";
import { useState, useContext, useEffect } from "react";
import { createContext } from "react";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { API_PROXY } from "../services/apiUrls";

const TasksContext = createContext({
  tasks: [],
  submitTask: () => {},
  resetSubmitTask: () => {},
  isLoading: false,
  isError: false,
  error: null,
  task: null,
  submitLoading: false,
  submitIsError: false,
  submitError: null,
  submitData: null,
  submitAttemptId: null,
  nameseo: null,
  setNameseo: () => {},
  currentTask: null,
  setCurrentTask: () => {},
});

export const TasksProvider = ({ children, initialNameseo = null }) => {
  const [nameseo, setNameseo] = useState(initialNameseo);
  const [currentTask, setCurrentTask] = useState(null);
  const [submitAttemptId, setSubmitAttemptId] = useState(null);

  const queryClient = useQueryClient();

  const {
    isLoading,
    isError,
    error,
    data: taskData,
  } = useQuery(
    ["task", nameseo],
    async () => {
      const { data } = await axios.post(`${API_PROXY}getTask`, { nameseo });
      return data;
    },
    {
      enabled: !!nameseo,
    }
  );

  queryClient.setMutationDefaults("submitTask", {
    mutationFn: async (dataToSend) => {
      let url = `${API_PROXY}submitSonicboxTask`;
      const { data } = await axios.post(url, dataToSend);
      return data;
    },
    onSuccess: (result, variables, context) => {
      // Replace optimistic todo in the user list with the result
      queryClient.setQueryData("submitTask", (old) => result);
      return result;
    },
    onError: (error, variables, context) => {
      console.log(
        "on submitTask error",
        error,
        error.response,
        variables,
        context
      );
      // Remove optimistic user from the user list
      queryClient.setQueryData("submitTask", (old) => null);
    },
    retry: 1,
  });

  const {
    mutateAsync,
    reset,
    isLoading: submitLoading,
    isError: submitIsError,
    error: submitError,
    data: submitData,
  } = useMutation("submitTask");

  const submitTask = async (params) => {
    setSubmitAttemptId(params?.eventAttemptId ?? null);
    return mutateAsync(params);
  };

  const resetSubmitTask = () => {
    setSubmitAttemptId(null);
    reset();
  };

  return (
    <TasksContext.Provider
      value={{
        submitTask,
        resetSubmitTask,
        isLoading: isLoading,
        isError: isError,
        error: error,
        tasks: taskData,
        submitLoading: submitLoading,
        submitIsError: submitIsError,
        submitError: submitError,
        submitData: submitData,
        submitAttemptId,
        nameseo: nameseo,
        setNameseo: setNameseo,
        currentTask,
        setCurrentTask,
      }}
    >
      {children}
    </TasksContext.Provider>
  );
};

export const useTasks = (nameseo) => {
  const taskContextData = useContext(TasksContext);
  const { setNameseo } = taskContextData;
  useEffect(() => {
    setNameseo(nameseo);
  }, [nameseo, setNameseo]);
  return taskContextData;
};
